import { API_COMMON_BASE_URL } from 'app-shared/lib/api/utils/api.constants';
import { RESERVATION_URL } from '../reservation.constants';
import { RESERVATION_STATUS } from '../reservation-status.type';

export const buildShopReservationsUrl = (shopId: number): string => {
  const url = `${API_COMMON_BASE_URL}/${RESERVATION_URL}/shops/${shopId}/reservations`;

  return url;
};

export const buildShopReservationsCountUrl = (
  shopId: number,
  startDate: Date,
  endDate: Date,
  statuses: RESERVATION_STATUS[]
): string => {
  const statusesQueryStringPart = statuses.map((status) => `&status=${status}`).join('');
  const url = `${buildShopReservationsUrl(
    shopId
  )}/count?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}${statusesQueryStringPart}`;

  return url;
};

export const buildReservationsUrl = (): string => {
  const url = `${API_COMMON_BASE_URL}/${RESERVATION_URL}/reservations`;

  return url;
};

export const buildAvailabilitiesUrl = (
  shopId: number,
  googlePlaceId: string,
  guestCount: number,
  startDate: Date,
  limit: number
): string => {
  const encodedPlaceId = encodeURIComponent(googlePlaceId);
  const url = `${API_COMMON_BASE_URL}/${RESERVATION_URL}/availabilities?shopId=${shopId}&googlePlaceId=${encodedPlaceId}&guestCount=${guestCount}&startDate=${startDate.toISOString()}&limit=${limit}`;

  return url;
};

export const buildKeyUrl = (action: 'accept' | 'reject' | 'cancel' | 'reconfirm', key: string): string => {
  const url = `${buildReservationsUrl()}/${action}?key=${encodeURIComponent(key)}`;

  return url;
};
